import { Box, Collapse, IconButton, styled, Typography } from "@mui/material";

export const ActionCardWrapper = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: "12px",
  padding: "16px",
  backgroundColor: theme.palette.background.paper,
  cursor: "pointer",
  display: "flex",
  flexDirection: "column",
  gap: "8px",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  "&:hover": {
    boxShadow: theme.shadows[6],
    transform: "translateY(-3px) scale(1.02)",
  },
}));

export const ActionCardHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "8px",
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.action.hover,
}));

export const ActionCardBody = styled(Box)({
  display: "flex",
  flexDirection: "column",
  gap: "12px",
});

export const InfoGrid = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: theme.spacing(1),
  "& > div": {
    minWidth: 0,
  },
}));

export const InfoItem = styled(Box, {
  shouldForwardProp: (prop) => prop !== "fullWidth",
})<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
  padding: theme.spacing(0.5, 0),
  gridColumn: fullWidth ? "1 / -1" : "auto",
}));

export const InfoIconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "20px",
  height: "20px",
  marginRight: theme.spacing(1),
  color: theme.palette.text.secondary,
}));

export const InfoContent = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  minWidth: 0,
  gap: theme.spacing(0.2),
}));

export const InfoLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.75rem",
  fontWeight: 600,
  color: theme.palette.text.secondary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const InfoValue = styled(Typography)(({ theme }) => ({
  fontSize: "1rem",
  fontWeight: 500,
  color: theme.palette.text.primary,
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
}));

export const Tag = styled(Box)<{ color?: string }>(({ theme, color }) => ({
  backgroundColor: color === "primary" ? theme.palette.primary.main : theme.palette.secondary.main,
  color: theme.palette.getContrastText(color === "primary" ? theme.palette.primary.main : theme.palette.secondary.main),
  borderRadius: "8px",
  padding: "4px 8px",
  fontSize: "0.8rem",
  fontWeight: 600,
  textTransform: "uppercase",
  boxShadow: theme.shadows[1],
}));

export const DescriptionPreview = styled(Typography)({
  fontSize: "0.875rem",
  lineHeight: "1.4",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const ExpandIconWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  transition: "transform 0.3s ease",
}));

export const StyledExpandIcon = styled(IconButton)({
  padding: "4px",
  margin: "0 auto",
  "& svg": {
    fontSize: "1.2rem",
  },
});

export const AnimatedCollapse = styled(Collapse)({
  transition: "height 0.3s ease",
});

export const ActionCardHeaderWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  minWidth: 0,
  flexGrow: 1,
});

export const ActionCardTitleBox = styled(Box)({
  minWidth: 0,
  flexGrow: 1,
  overflow: "hidden",
});

export const ActionCardTitle = styled(Typography)({
  textOverflow: "ellipsis",
  overflow: "hidden",
  whiteSpace: "nowrap",
  minWidth: 0,
  width: "96%",
});
